import PropTypes from 'prop-types';
import { ReactComponent as Age } from '../../assets/icons/small/age.svg';
import { ReactComponent as Diet } from '../../assets/icons/small/diet.svg';
import { ReactComponent as Enemy } from '../../assets/icons/small/enemy.svg';
import { ReactComponent as Friendlyness } from '../../assets/icons/small/friendlyness.svg';
import { ReactComponent as Scanner } from '../../assets/icons/small/scanner.svg';
import { ReactComponent as Size } from '../../assets/icons/small/size.svg';

const InfoIcon = ({ type }) => {
	const getIcon = () => {
		switch (type) {
			case 'size':
				return <Size className="overflow-visible" />;
			case 'friendlyness':
				return <Friendlyness className="overflow-visible" />;
			case 'age':
				return <Age className="overflow-visible" />;
			case 'enemy':
				return <Enemy className="overflow-visible" />;
			case 'diet':
				return <Diet className="overflow-visible" />;
			case 'scanner':
				return <Scanner className="overflow-visible" />;
			default:
				return <></>;
		}
	};

	return (
		<div className="pt-2 overflow-visible" style={{ transform: 'scale3d(1.1, 1.1, 1.1)' }}>
			{getIcon()}
		</div>
	);
};

export default InfoIcon;

InfoIcon.propTypes = {
	type: PropTypes.string.isRequired,
};
